/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/*
用途：检查输入字符串是否符合金额格式
格式定义为带小数的正数，小数点后最多两位
输入：
s：字符串
返回：
如果通过验证返回true,否则返回false
*/
export function isPrice(s) {
  if (/^(\d+|\d+\.\d{1,2})$/.test(s)) {
    return true;
  } else {
    return false;
  }
}

export function isLoginPassword(s) {
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/.test(s)) {
    return false
  }

  const normalized = s.toLowerCase()
  for (let i = 2; i < normalized.length; i++) {
    const first = normalized.charCodeAt(i - 2)
    const second = normalized.charCodeAt(i - 1)
    const third = normalized.charCodeAt(i)
    if (/^[a-z0-9]{3}$/.test(normalized.slice(i - 2, i + 1))
      && second - first === third - second
      && Math.abs(second - first) === 1) {
      return false
    }
  }

  for (let sequenceLength = 1; sequenceLength <= 4; sequenceLength++) {
    const repeatedLength = sequenceLength * 3
    for (let start = 0; start + repeatedLength <= normalized.length; start++) {
      const sequence = normalized.slice(start, start + sequenceLength)
      if (sequence === normalized.slice(start + sequenceLength, start + sequenceLength * 2)
        && sequence === normalized.slice(start + sequenceLength * 2, start + repeatedLength)) {
        return false
      }
    }
  }

  return true
}
